.d6{font-size:0.75rem;}